/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoTransazioneVoucher } from './tipo-transazione-voucher';


export interface TransazioneVoucherBackofficeListFilter { 
    id_pratica?: string;
    codice_voucher?: string;
    data_da?: string;
    data_a?: string;
    id_negozio?: string;
    tipo_transazione?: TipoTransazioneVoucher;
    intestatario?: string;
}



